import React, { useEffect, useState } from 'react';

// Digital HIG Components
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
 import { useCfpAuthUtilities } from '../../providers/CfpAuthContext';
import logger from '../../utils/logger';

interface InfoItemProps {
  label: string;
  value: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => {
  const isLeftItem = label === 'Generated by' || label === 'Account Name';
  
  return (
    <DHBox
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: isLeftItem ? '441px' : '287px',
        flexShrink: 0
      }}
    >
      <DHTypography
        variant="caption"
        sx={{
          fontFamily: 'Artifakt Element',
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          letterSpacing: '0%',
          verticalAlign: 'bottom',
          color: 'ink-on-background-60',
          marginBottom: 1
        }}
      >
        {label}
      </DHTypography>
      <DHTypography
        variant="caption"
        sx={{
          fontFamily: 'Artifakt Element',
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '20px',
          letterSpacing: '0%',
          color: 'ink-on-background',
          whiteSpace: 'normal',
          // Allow long values to wrap within the column without clipping
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          maxWidth: '100%'
        }}
      >
        {value}
      </DHTypography>
    </DHBox>
  );
};

interface InfoSectionProps {
  generatedBy?: string;
  customerName?: string;
  accountCSN?: string;
}

export const InfoSection: React.FC<InfoSectionProps> = ({ 
  generatedBy, 
  customerName, 
  accountCSN 
}) => {
  const { cfpAuthUtils } = useCfpAuthUtilities();
  const [userName, setUserName] = useState<string>('User');
  
  useEffect(() => {
    try {
      // Try to get cached user info
      const cachedUserInfo = cfpAuthUtils.getCachedUserInfo();
      if (cachedUserInfo?.userName) {
        setUserName(cachedUserInfo.userName);
      }
    } catch (error) {
      logger.error('Failed to get user info:', error);
      // Keep default 'Unknown User' on error
    }
  }, [cfpAuthUtils]);

  const currentTime = new Date().toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });

  const finalGeneratedBy = generatedBy || userName;

  return (
    <>
      {/* Generated By / Created On Section */}
      <DHBox
        sx={{
          padding: 2,
          backgroundColor: '#ffffff',
          borderRadius: 1,
          minHeight: '40px',
          display: 'flex',
          gap: 1,
          width: '736px'
        }}
      >
        <InfoItem label="Generated by" value={finalGeneratedBy} />
        <InfoItem label="Created on" value={currentTime} />
      </DHBox>

      {/* Account Name / Account CSN Section */}
      <DHBox
        sx={{
          padding: 2,
          backgroundColor: '#ffffff',
          borderRadius: 1,
          minHeight: '40px',
          display: 'flex',
          gap: 1,
          width: '736px'
        }}
      >
        <InfoItem label="Account Name" value={customerName || 'N/A'} />
        <InfoItem label="Account CSN" value={accountCSN || 'N/A'} />
      </DHBox>
    </>
  );
};

